// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
var CHROME_REGEX = /(chrome)[ \/]([\w.]+)/i;
var SAFARI_REGEX = /(webkit)[ \/]([\w.]+)/i;
/**
 * @hidden
 */

/**
 * Represents the default `UploadInput` component.
 */

var UploadInputVue2 = {
  name: 'KendoVueUploadInput',
  props: {
    async: Object,
    multiple: {
      type: Boolean,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: undefined
    },
    accept: {
      type: String,
      default: undefined
    }
  },
  // @ts-ignore
  emits: {
    'mousedown': null,
    'add': null
  },
  mounted: function mounted() {
    this._input = this.v3 ? this.inputRef : this.$refs.input;
  },
  methods: {
    onMouseDown: function onMouseDown(e) {
      this.$emit('mousedown', e);
    },
    onAdd: function onAdd() {
      var ua = navigator.userAgent;
      var input = this._input;

      if (input) {
        if (input.files) {
          this.$emit('add', input.files);
        }
        /*
            Chrome and Internet Explorer do not trigger a `change` event
            when a file with the same name is selected a number of consecutive times.
            As a workaround, clear the input value after handling the file.
        */


        if (!(!ua.match(CHROME_REGEX) && ua.match(SAFARI_REGEX))) {
          input.type = '';
          input.type = 'file';
        }
      }
    },
    actionElement: function actionElement() {
      return this._input;
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var inputRef = ref(null);
    return {
      v3: v3,
      inputRef: inputRef
    };
  },
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        multiple = _a.multiple,
        async = _a.async,
        disabled = _a.disabled,
        accept = _a.accept;
    return h("input", {
      ref: this.v3 ? function (el) {
        _this.inputRef = el;
      } : 'input',
      autoComplete: 'off',
      attrs: this.v3 ? undefined : {
        autoComplete: 'off',
        name: async.saveField,
        accept: accept,
        type: 'file',
        tabIndex: -1,
        multiple: multiple,
        disabled: disabled
      },
      name: async.saveField,
      accept: accept,
      type: 'file',
      tabIndex: -1,
      multiple: multiple,
      disabled: disabled,
      onChange: this.onAdd,
      on: this.v3 ? undefined : {
        "change": this.onAdd,
        "mousedown": this.onMouseDown
      },
      onMousedown: this.onMouseDown
    });
  }
};
var UploadInput = UploadInputVue2;
export { UploadInput, UploadInputVue2 };